optinActionDetails.$inject = ['$state', 'AngularOptinsService'];
export function optinActionDetails($state, AngularOptinsService) {

  OptinActionDetailsController.$inject = ['$scope'];
  function OptinActionDetailsController($scope) {

    $scope.selectOptin = selectOptin;
    $scope.goToOptins = goToOptins;
  
    init();
  
    function selectOptin(optin) {
      $scope.action.selectedOptin = optin;
    }
  
    function goToOptins(){
      $scope.closeModalFn();
      $state.go('auth.alcmeon.fuse.optins');
    }
  
    function init() {
      $scope.OPTIN_TYPE_DEFAULT = AngularOptinsService.OPTIN_TYPE_DEFAULT;
      let selectedOptin = {};
      if ($scope.optins) {
        if ($scope.action.optin && $scope.action.optin.id) {
          selectedOptin = $scope.optins.find(optin => optin.id == $scope.action.optin.id);
        } else {
          if ($scope.optins.length > 0) {
            selectedOptin = $scope.optins[0];
          }
        }
      }
      $scope.action.selectedOptin = selectedOptin;
    }
  }

  return {
    restrict: 'E',
    template: require('./optin-action-details.directive.html'),
    scope: {
      action: "=",
      optins: "=",
      closeModalFn: "&closeModal"
    },
    controller: OptinActionDetailsController
  };

}
